class templateModalCtrl {
    constructor($scope, $uibModalInstance, httpRequest, items1, logger) {
        $scope.currentIndex = 0
        $scope.formDataList = [
            {
                code: '',
                templates: [],
            },
        ]
        console.log(items1)
        const items = items1 || JSON.parse(localStorage.user_info).sale
        httpRequest.get_getProvince().then((res) => {
            $scope.cityData = res.data.value
            if (items.sfdqDm) {
                for (let i = 0; i < $scope.cityData.length; i++) {
                    for (let j = 0; j < $scope.cityData[i].cityList.length; j++) {
                        if (items.sfdqDm == $scope.cityData[i].cityList[j].sfdqDm) {
                            $scope.defaultCity = $scope.cityData[i].cityList[j]
                            $scope.defaultProvince = $scope.cityData[i]
                        }
                    }
                }
            } else {
                $scope.defaultProvince = $scope.cityData[0]
                $scope.defaultCity = $scope.defaultProvince.cityList[0]
            }
            httpRequest.get_dictByType('zsxm_dm').then((res) => {
                $scope.enumConfig = res.data.value
                $scope.formDataList[0].code = $scope.enumConfig[0].enumCode
                if (items.sfdqDm) {
                    const reqObj = { dqdm: items.sfdqDm, zsxmdm: $scope.enumConfig[0].enumCode }

                    $scope.formDataArr = $scope.formDataList[0].templates = initTemplateModal(reqObj)
                } else {
                    const reqObj = { dqdm: $scope.defaultCity.sfdqDm, zsxmdm: $scope.enumConfig[0].enumCode }
                    $scope.formDataArr = $scope.formDataList[0].templates = initTemplateModal(reqObj)
                }
            })
        })
        $scope.cancel = () => {
            $uibModalInstance.close()
        }
        $scope.getProvince = function () {
            $scope.formDataList = [
                {
                    code: '',
                    templates: [],
                },
            ]
            $scope.defaultCity = $scope.defaultProvince.cityList[0]
            const reqObj = { dqdm: $scope.defaultCity.sfdqDm, zsxmdm: $scope.enumConfig[0].enumCode }
            $scope.formDataList[0].code = $scope.enumConfig[0].enumCode
            $scope.formDataArr = $scope.formDataList[0].templates = initTemplateModal(reqObj)
        }
        $scope.getCity = function () {
            $scope.formDataList = [
                {
                    code: '',
                    templates: [],
                },
            ]
            const reqObj = { dqdm: $scope.defaultCity.sfdqDm, zsxmdm: $scope.enumConfig[0].enumCode }
            $scope.formDataList[0].code = $scope.enumConfig[0].enumCode
            $scope.formDataArr = $scope.formDataList[0].templates = initTemplateModal(reqObj)
        }

        function initTemplateModal(reqObj) {
            const resList = [{ sydx: '', arr: [], checkFlag: false }]
            httpRequest.get_getModelByDqSz(reqObj).then((res) => {
                const resArr = res.data.value

                for (let y = 0; y < resArr.length; y++) {
                    let flag = true
                    for (let x = 0; x < resList.length; x++) {
                        if (resList[x].sydx == resArr[y].sydx) {
                            resList[x].arr.push(resArr[y])
                            flag = false
                        }
                    }
                    if (flag) resList.push({ sydx: resArr[y].sydx, arr: [resArr[y]] })
                }
                resList.splice(0, 1)
                for (let r = 0; r < resList.length; r++) {
                    let checkFlag = false
                    for (let e = 0; e < resList[r].arr.length; e++) {
                        if (resList[r].arr[e].choseState) {
                            checkFlag = true
                            break
                        }
                    }
                    resList[r].checkFlag = checkFlag
                }
            })
            return resList
        }

        $scope.getTaxes = function (index) {
            const reqObj = { dqdm: $scope.defaultCity.sfdqDm, zsxmdm: $scope.enumConfig[index].enumCode }
            let codeFlag = true
            for (let o = 0; o < $scope.formDataList.length; o++) {
                if ($scope.formDataList[o].code == $scope.enumConfig[index].enumCode) {
                    codeFlag = false
                }
            }
            if (codeFlag) {
                $scope.formDataList.push({
                    code: $scope.enumConfig[index].enumCode,
                    templates: initTemplateModal(reqObj),
                })
            }
            $scope.formDataArr = $scope.formDataList.filter((item) => item.code === $scope.enumConfig[index].enumCode)[0].templates
            $scope.currentIndex = index
        }

        $scope.radioChange = function () {
            if (this.$parent.item.checkFlag) {
                const { arr } = this.$parent.item
                for (let z = 0; z < arr.length; z++) {
                    arr[z].choseState = 0
                }
                this.data.choseState = 1
            }
        }
        $scope.checkboxChange = function (v) {
            if (v) {
                this.item.arr[0].choseState = 1
            } else {
                for (let index = 0; index < this.item.arr.length; index++) {
                    this.item.arr[index].choseState = 0
                }
            }
        }
        $scope.tempModalSure = function () {
            let reqArr = []
            for (let u = 0; u < $scope.formDataList.length; u++) {
                for (let q = 0; q < $scope.formDataList[u].templates.length; q++) {
                    for (let w = 0; w < $scope.formDataList[u].templates[q].arr.length; w++) {
                        const item = $scope.formDataList[u].templates[q].arr[w]
                        reqArr.push({ flag: item.choseState, mbuuid: item.mbuuid, sfdqDm: $scope.defaultCity.sfdqDm })
                    }
                }
            }
            if (!reqArr.length) reqArr = [{ sfdqDm: $scope.defaultCity.sfdqDm }]
            httpRequest.post_modelManage(reqArr).then((res) => {
                if (res.data.success) {
                    logger.logSuccess('提交成功')
                    $uibModalInstance.close()
                }
            })
        }
    }
}

templateModalCtrl.$inject = ['$scope', '$uibModalInstance', 'httpRequest', 'items1', 'logger']
export default templateModalCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/templateSetting/templateModalCtrl.js